export const moviesList = [
	{
		_id: 1,
		title: 'The harder they fall',
		description: 'some text to describe the movie.',
		start_date: new Date().valueOf(),
		end_date: new Date().valueOf() + 7,
		photoUrl: 'thtf.jpg'
	},
	{
		_id: 2,
		title: 'The Pirates of the carribean',
		description: 'some text to describe the movie.',
		start_date: new Date().valueOf(),
		end_date: new Date().valueOf() + 7,
		photoUrl: 'pirates1.jpg'
	},
	{
		_id: 3,
		title: 'Matrix',
		description: 'some text to describe the movie.',
		start_date: new Date().valueOf(),
		end_date: new Date().valueOf() + 7,
		photoUrl: 'matrix.jpg'
	},
	{
		_id: 4,
		title: 'John Wick',
		description: 'some text to describe the movie.',
		start_date: new Date().valueOf(),
		end_date: new Date().valueOf() + 7,
		photoUrl: 'john_wick.jpg'
	},
	// {
	// 	_id: 5,
	// 	title: 'The harder they fall',
	// 	description: 'some text to describe the movie.',
	// 	start_date: new Date().valueOf(),
	// 	end_date: new Date().valueOf() + 7,
	// 	photoUrl: ''
	// },
]